import { HorizontalContainer } from "@/components/layout/horizontal-container";
import { HorizontalSpacer } from "@/components/layout/horizontal-spacer";
import { VerticalSpacer } from "@/components/layout/vertical-spacer";
import { Text } from "@/components/ui/text";
import type { ReactNode } from "react";
import { PencilIcon, PlaceholderIcon } from "../../icons/icons";

interface SummaryItemProps {
  children: ReactNode;
  color?: "primary";
  heading: string;
  horizontalPlacement?: "space";
  onClick?: () => void;
  showRuler?: boolean;
  weight?: "bold";
  hasPlaceholderIcon?: boolean;
}

export const SummaryItem = ({
  children,
  color,
  hasPlaceholderIcon,
  heading,
  horizontalPlacement,
  onClick,
  showRuler,
  weight,
}: SummaryItemProps) => (
  <>
    <HorizontalContainer horizontalPlacement="space" noWrap={true} verticalPlacement="center" width="full">
      <HorizontalContainer
        horizontalPlacement={horizontalPlacement ?? undefined}
        noWrap={horizontalPlacement === "space" ? true : undefined}
        verticalPlacement="center"
        width={horizontalPlacement === "space" ? "full" : undefined}
      >
        <Text color={color ?? undefined} value={heading} weight={weight ?? undefined} />
        <VerticalSpacer size="xx-small" />
        {children}
      </HorizontalContainer>

      {onClick && (
        <button type="button" onClick={onClick}>
          <PencilIcon />
        </button>
      )}

      {hasPlaceholderIcon && <PlaceholderIcon name="placeholder icon" />}
    </HorizontalContainer>
    {showRuler && (
      <>
        <HorizontalSpacer />
        <hr />
        <HorizontalSpacer />
      </>
    )}
  </>
);
